import defaults from "nodemon/lib/config/defaults";
import React, { useEffect, useState } from 'react';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import { Form } from 'react-bootstrap';
import RaiseRequest from "../RaiseRequest";

let allcorporate=[]
const RaiseReqSelectScheme = (props) =>{
 let history=useHistory()
   let [scheme, setscheme]=useState([])
 let [call_log_user, setget_call_log_user]=useState({})
let [selected_scheme, setselected_sceme]=useState('')
let [selected_scheme_name, set_selected_scheme_name] = useState('')

// const [data, setdata]=useState({
//   auth:false,
//   loading:false,
//   userDetails:{}
// })

const raiserequest=()=>{
  window.location.reload(true)
 /* history.push('/raiserequest') */
}


// console.log('dkmksmks',props)
const fetscallScheme=()=>{
    console.log('testin============g',props.userData.id)
    axios.get('/get_schemes_stamp_paper?user_id='+props.userData.id).then((res)=>{
      console.log(res,'teesting============2')
      allcorporate=[]
      if(Array.isArray(res.data.data)){
        res.data.data.forEach(key=>{
          if(JSON.parse(key.id)===JSON.parse(props.userData.corporate_id)){
            setselected_sceme(key.id)
            set_selected_scheme_name(key.scheme_name)
            setselected_sceme(key.scheme_name)
          }
        })
        for(let i=0;i<props.userData.corporate.length;i++){
          res.data.data.forEach(key=>{
            if(props.userData.corporate[i].toLowerCase()===key.scheme_name.toLowerCase()){
              allcorporate.push({id:key.id, scheme_name:key.scheme_name, payment_mode:key.payment_mode})
            }
          })
        }
      }
      setscheme(res.data.data)
    })
  }
//       console.log('props.userData.roles', props.userRole)
      const get_call_log_user=()=>{
        axios.get('/get_call_log_user?user_id='+props.userData.id).then((res)=>{
          if(res.data){
            if(res.data.length!==0){
              setget_call_log_user(res.data[0])
            }
          }
          // else{
          //   setdata({...data, auth:false,loading:true, userDetails:{}})
          // }
        })
      }
      const getdata=(ev)=>{
        let date_from=''
        if(ev){
          date_from=new Date(ev).toDateString()
        }
        return date_from
      }
      const gettime =(ev)=>{
        let time=''
        if(ev){
           time=new Date(ev).toLocaleTimeString('en',
          { timeStyle: 'short', hour12: true });
        }
        return time;
      }
      console.log('call_log_user',allcorporate, selected_scheme)     
      useEffect(()=>{
        fetscallScheme()
        get_call_log_user()
      }, [])
      console.log('props.userData.corporate_id',props.userData.id,'testing', props.userData.corporate_id)
    
    
      // if(data.loading){
      //   return(
      //     <div>
      //    <RaiseRequest onClick={raiserequest} />
      //    </div>
      //   )
      // }
      // else{

        // if(data.loading){
    return(
        <>
         <div className='mainuserdet' style={{
            backgroundColor: "red", height: "60%", display: "flex", justifyContent: "center"
          }}>
            <div className="text-center" style={{ alignSelf: "center", width: "100%", height: "100%", fontSize: "28px", background: "#98AFC7", paddingTop:"20%",paddingBottom:"20%" }}>
    
              <Form className="scheme-form" style={{ background: "#fff",
   margin:"-12% 10% 30% 35%", height:"30rem",width:"30rem", borderRadius: "10px 10px 10px 10px",boxShadow: "0 30px 60px 0 rgba(0,0,0,0.3)" }} >
              <Form.Group className="mb-10" style={{paddingTop:"20%"}}>
              <Form.Label>Choose Scheme</Form.Label><br />


              <select value={selected_scheme} onChange={(scheme_sele=>{
        console.log(scheme_sele.target.value)
        axios.get('/update_scheme?corporate_id='+scheme_sele.target.value+'&select_by=raise_req').then(res=>{         
          history.push('/raiserequest')
          history.go(0)
          
        })
      })} style={{width:"85%", fontSize:"16px"}} >
      
       <option>Selected Scheme</option>
       <br></br>
       {/* <option key={-1} value="" disabled></option> */}
        {Array.isArray(props.userData.corporate)&&
          allcorporate.map((schemeval, i)=>{
        return(
             <option key={i} value={schemeval.id} onClick={raiserequest} >{schemeval.scheme_name}</option>
              )
        }
        )  
        }
        
        </select>

        </Form.Group>
        </Form>
    </div>
    </div>
        </>
    )
  // } else{
  //   return(
  //     <div>
  //    <RaiseRequest onClick={raiserequest} />
  //    </div>
  //   )
  // }
}
export default RaiseReqSelectScheme;